import { render, staticRenderFns } from "./GoogleSignIn.vue?vue&type=template&id=3a0b6af8&"
import script from "./GoogleSignIn.vue?vue&type=script&lang=js&"
export * from "./GoogleSignIn.vue?vue&type=script&lang=js&"
import style0 from "./GoogleSignIn.vue?vue&type=style&index=0&id=3a0b6af8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports